// @flow
import {
    CHECK_AUTH_TYPE,
    CHECK_AUTH_TYPE_FAILED,
    CHECK_AUTH_TYPE_SUCCESS,
    FORGET_PASSWORD,
    FORGET_PASSWORD_FAILED,
    FORGET_PASSWORD_SUCCESS,
    LOGIN_USER,
    LOGIN_USER_FAILED,
    LOGIN_USER_SUCCESS,
    LOGOUT_USER,
    REGISTER_LINKED_ACCOUNT,
    REGISTER_USER,
    REGISTER_USER_FAILED,
    REGISTER_USER_SUCCESS,
    FETCH_USER_PROFILE_SUCCESS,
    FETCH_USER_PROFILE_FAILED,
    INIT_AUTH,
    INIT_AUTH_SUCCESS,
    INIT_AUTH_FAILED,
} from './constants';

import {setAuthTypeConfigs} from "../../../shared/configUtils";

const INIT_STATE = {
    user: null,
    userInfo: null,
    authType: 'OAUTH',
    loading: false,
    authInitialized: false,
    authInitializing: false,
};

type AuthAction = { type: string, payload: {} | string };
type State = { user?: {} | null, userInfo?: {} | null, authType?: string, loading?: boolean, +value?: boolean };

const Auth = (state: State = INIT_STATE, action: AuthAction) => {
    switch (action.type) {
        case INIT_AUTH:
            return {...state, authInitializing: true};
        case INIT_AUTH_SUCCESS:
            return {...state, authInitialized: true, authInitializing: false};
        case INIT_AUTH_FAILED:
            return {...state, authInitialized: true, authInitializing: false, user: null, userInfo: null};
        case CHECK_AUTH_TYPE:
            return {...state, loading: true};
        case CHECK_AUTH_TYPE_SUCCESS:
            setAuthTypeConfigs(action.payload.type);
            return {
                ...state,
                authType: action.payload.type,
                config: action.payload.config,
                corp: action.payload.corp,
                domain: action.payload.domain,
                loading: false,
                error: null
            };
        case CHECK_AUTH_TYPE_FAILED:
            return {...state, authType: null, error: action.payload, loading: false};
        case REGISTER_LINKED_ACCOUNT:
            return {...state, loading: true};
        case LOGIN_USER:
            return {...state, loading: true};
        case LOGIN_USER_SUCCESS:
            return {...state, user: action.payload, loading: false, error: null};
        case LOGIN_USER_FAILED:
            return {...state, error: action.payload, loading: false};
        case FETCH_USER_PROFILE_SUCCESS:
            return {...state, userInfo: action.payload};
        case FETCH_USER_PROFILE_FAILED:
            return {...state, userInfo: null};
        case REGISTER_USER:
            return {...state, loading: true};
        case REGISTER_USER_SUCCESS:
            return {...state, user: action.payload, loading: false, error: null};
        case REGISTER_USER_FAILED:
            return {...state, error: action.payload, loading: false};
        case LOGOUT_USER:
            return {...state, user: null, userInfo: null};
        case FORGET_PASSWORD:
            return {...state, loading: true};
        case FORGET_PASSWORD_SUCCESS:
            return {...state, passwordResetStatus: action.payload, loading: false, error: null};
        case FORGET_PASSWORD_FAILED:
            return {...state, error: action.payload, loading: false};
        default:
            return {...state};
    }
};

export default Auth;
